module.exports = __webpack_public_path__ + "static/img/11.245ec7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/eng/11.png
// module id = JVvl
// module chunks = 0